import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import {
  ButtonsModule,
  CardModule,
  CheckboxModule,
  ModalModule,
} from 'axis-components';
import { ModalUimuiDisclosurePdfComponent } from '../modal-uimui-disclosure-pdf/modal-uimui-disclosure-pdf.component';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-modal-uimui-review-state-pdf',
  templateUrl: './modal-uimui-review-state-pdf.component.html',
  styleUrl: './modal-uimui-review-state-pdf.component.scss',
  standalone: true,
  imports: [
    ModalModule,
    CardModule,
    ButtonsModule,
    CommonModule,
    CheckboxModule,
    FormsModule,
    ReactiveFormsModule,
    ModalUimuiDisclosurePdfComponent,
  ],
})
export class ModalUimuiReviewStatePdfComponent {
  @ViewChild('modalStateReview') modalStateReview;
  @Input() uninsuredSelection: FormGroup;
  @Output() modalResult = new EventEmitter<boolean>();
  isVisible = false;
  constructor(private fb: FormBuilder) {}

  open(): void {
    this.modalStateReview.open();
  }

  onContinueClick() {
    const control = this.uninsuredSelection.get('undoConfirmStateDis');
    if (control?.valid) {
      this.modalStateReview.close();
      this.modalResult.emit(true);
    } else {
      this.modalResult.emit(false);
      control?.markAsTouched();
      control?.markAsDirty();
    }
  }
}
